import { merge } from 'lodash-es';

const mergeMessages = (
  overridingMessages: Record<string, Record<string, string>>,
  baseMessages: Record<string, Record<string, string>>,
  locales: string[] = ['en-CA', 'fr-CA']
) => {
  locales.forEach(locale => {
    const baseMessage = baseMessages[locale];
    if (baseMessage) {
      const overridingMessage = overridingMessages[locale];
      if (overridingMessage) {
        merge(baseMessage, overridingMessage);
        baseMessages[locale] = baseMessage;
      }
    }
  });
  return baseMessages;
};

export default mergeMessages;
